export default "__VITE_ASSET__BXRpx5Bh__"